import { makeStyles } from '@material-ui/core';
import themes from 'styles/themes';

export const useStyles = makeStyles((theme) => ({
    container: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: '16px',
    },
    styleContainer: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        flexDirection: 'column',
    },
    fitContent: {
        width: '100%',
        height: '100%',
    },
    flexCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    subtitle: {
        fontSize: '14px',
        fontFamily: 'PoppinsRegular',
        color: '#767676',
        textAlign: 'center',
    },
    cardContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flex: 1,
        justifyContent: 'center',
    },
    title: {
        fontSize: 24,
        fontWeight: 600,
        marginBottom: '30px',
        textAlign: 'center',
        fontFamily: 'Fraunces_120pt_SuperSoft_Wonky-Regular',
    },
    button: {
        width: '100%',
        height: 50,
        padding: 0,
        fontSize: 14,
        fontWeight: 600,
        fontFamily: 'PoppinsRegular',
        background: themes.palette.primary.main,
        borderRadius: '29px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textTransform: 'uppercase',
        border: 'none',
        marginTop: 12,
    },
    pickerContainer: {
        height: '315px',
        '@media (max-height: 695px)': {
            height: '200px',
        },
    },
}));
